<template>
  <div>
    <div class="pageTitleController">
      <img src="@/assets/img/6.png" />
      <div class="marginLeft15">产品登记</div>
    </div>

    <!--顶部产品信息界面-->
    <Plan class="marginTop20" :miniPadding="true">
      <div class="chanpinTitleControler">
        <div class="ts">产品详情</div>
        <div class="flex"></div>
        <div
          @click="
            $router.push({
              name: 'ProductList'
            })
          "
          class="bank"
        >
          返回列表
        </div>
      </div>
    </Plan>
    <Plan
      v-if="formInfo.status === 'hidden'"
      class="marginTop20"
      :miniPadding="true"
    >
      <div class="jinshiText">停用原因： {{ stopinfo.stop_marks }}</div>
      <div class="jinshiText" v-if="stopinfo.stop_file">
        停用附件：
        <a :href="domain + stopinfo.stop_file" target="view_window">点击查看</a>
      </div>
      <div class="jinshiText">停用时间：{{ stopinfo.stop_time }}</div>
    </Plan>
    <!--审核状态展示-->
    <Plan v-if="show === 'confirm'" class="marginTop20" :miniPadding="true">
      <div>
        <!-- <div class="fankuiyijianController">
          <div class="fankuiyijian">审核状态</div>
          <div class="yijian">{{ check_text }}</div>
        </div> -->
        <div class="jinshiText">
          警示：请仔细核对产品信息，如信息有误，则点击产品信息有误按钮提交修改意见；如信息已准确，请点击确认按钮。
        </div>
      </div>
    </Plan>
    <!--反馈意见-->
    <Plan
      v-if="show === 'supplement' || show === 'confirm' || show === 'reBank'"
      class="marginTop20"
      :miniPadding="true"
    >
      <div class="fankuiyijianController">
        <div class="fankuiyijian">反馈意见</div>
        <div class="yijian">
          <span v-if="show === 'reBank'" style="color:red" v-html="checkmark">
          </span>
          <span v-else v-html="checkmark"></span>
        </div>
      </div>
    </Plan>

    <Plan class="marginTop20" title="产品信息录入（必填）">
      <div>
        <el-form :inline="true" class="plan-form-inline">
          <el-form-item v-if="!onlyshow" label="搜索分类" class="inline">
            <div v-if="!onlyshow" style="width: 317px;">
              <el-input placeholder="请输入产品类型" v-model="excelSo">
                <el-button
                  slot="append"
                  @click="showSelectCailiao = true"
                  icon="el-icon-search"
                ></el-button>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item :required="true" label="产品分类" class="inline">
            <div v-if="!onlyshow" style="width: 317px;">
              <Categoryselect
                style="width: 317px"
                class="formInput"
                v-model="product_cate"
              ></Categoryselect>
            </div>
            <el-input
              style="width: 317px;"
              v-else
              :readonly="onlyshow"
              :value="cate_tree"
              class="formInput readonlit"
            ></el-input>
          </el-form-item>
          <div></div>
          <el-form-item :required="true" label="产品名称" class="inline">
            <el-input
              :readonly="onlyshow"
              :class="onlyshow ? 'readonlit' : ''"
              v-model="formInfo.product_name"
              class="formInput"
            ></el-input>
          </el-form-item>
          <el-form-item
            :required="true"
            v-if="is_excelent_cate === '1'"
            label="优质类型"
            class="selecteExcelentCate"
          >
            <el-checkbox-group :disabled="onlyshow" v-model="excelent_cate">
              <el-checkbox-button
                v-for="(val, ind) in youzhiList"
                :label="val.id"
                :key="ind"
                >{{ val.name }}</el-checkbox-button
              >
            </el-checkbox-group>
          </el-form-item>
          <!--<el-form-item label="优质类型" class="inline">
            <el-select
            filterable v-model="excelent_cate" multiple class="formInput">
              <el-option
                class="formInput"
                v-for="(val, ind) in youzhiList"
                :key="ind"
                :label="val.name"
                :value="val.id"
              ></el-option>
            </el-select>
          </el-form-item>-->
          <!--规格型号容器-->
          <div></div>
          <el-form-item :required="true" label="国家标准" class="inline">
            <el-input
              :readonly="onlyshow"
              :class="onlyshow ? 'readonlit' : ''"
              v-model="formInfo.national_standard"
              class="formInput"
            ></el-input>
          </el-form-item>
          <el-form-item :required="true" label="行业标准" class="inline">
            <el-input
              :readonly="onlyshow"
              :class="onlyshow ? 'readonlit' : ''"
              v-model="formInfo.industry_standard"
              class="formInput"
            ></el-input>
          </el-form-item>
          <el-form-item
            :required="true"
            label="其他标准（协会、企业、团体标准）"
            class="inline"
          >
            <el-input
              :readonly="onlyshow"
              :class="onlyshow ? 'readonlit' : ''"
              v-model="formInfo.other_standard"
              class="formInput"
            ></el-input>
          </el-form-item>
          <el-form-item :required="true" label="设计产能" class="inline">
            <el-input
              :readonly="onlyshow"
              :class="onlyshow ? 'readonlit' : ''"
              v-model="formInfo.product_output"
              class="formInput"
            ></el-input>
          </el-form-item>
          <!--<el-form-item label="产品生产厂址" class="inline">
            <el-input :readonly="onlyshow"
            :class="onlyshow ? 'readonlit' : ''"
              v-model="formInfo.product_address"
              class="formInput"
            ></el-input>
          </el-form-item>-->
          <el-form-item
            :required="true"
            label="产能单位"
            class="inline productOutputCompany"
          >
            <el-select
              filterable
              v-if="!onlyshow"
              v-model="formInfo.product_unit"
              placeholder="请选择产能单位"
            >
              <!--<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
              <el-option
                v-for="val in danweiList"
                :key="val"
                :label="val"
                :value="val"
              ></el-option>
            </el-select>
            <el-input
              v-else
              :readonly="onlyshow"
              :value="formInfo.product_unit"
              class="formInput readonlit"
            ></el-input>
          </el-form-item>
          <p class="actualOutPutTitle">
            近三年实际产能
            <span>（如企业投入生产未满3年，可根据实际情况选填）</span>
          </p>
          <div v-if="formInfo.product_unit" class="actualOutPut">
            <el-form-item :label="now_years - 1 + '年实际产能'" class="inline">
              <el-input
                :readonly="onlyshow"
                :class="onlyshow ? 'readonlit' : ''"
                v-model="formInfo.one_year"
              >
              </el-input
              >{{ formInfo.product_unit }}
            </el-form-item>
            <el-form-item :label="now_years - 2 + '年实际产能'" class="inline">
              <el-input
                :readonly="onlyshow"
                :class="onlyshow ? 'readonlit' : ''"
                v-model="formInfo.two_year"
              ></el-input
              >{{ formInfo.product_unit }}
            </el-form-item>
            <el-form-item :label="now_years - 3 + '年实际产能'" class="inline">
              <el-input
                :readonly="onlyshow"
                :class="onlyshow ? 'readonlit' : ''"
                v-model="formInfo.three_year"
              ></el-input
              >{{ formInfo.product_unit }}
            </el-form-item>
          </div>
          <div>
            <el-form-item :required="true" label="产地" class="productArea">
              <div
                class="areSelectaddress"
                v-for="(addss, inx) in formInfo.registered_address"
                :key="inx"
              >
                <Areselect
                  :onlyshow="onlyshow"
                  v-model="addss.areCodeList"
                ></Areselect>
                <el-input
                  :readonly="onlyshow"
                  :class="onlyshow ? 'readonlit' : ''"
                  v-model="addss.detail"
                  placeholder="请补全详细地址"
                  class="productArea_address marginLeft20"
                ></el-input>
                <div v-if="!onlyshow">
                  <i
                    v-if="
                      parseInt(inx + 1) === formInfo.registered_address.length
                    "
                    class="el-icon-circle-plus-outline btn-icon"
                    @click="addDress"
                  ></i>
                  <i
                    v-if="inx > 0"
                    class="el-icon-remove-outline btn-icon"
                    @click="removeDress(inx)"
                  ></i>
                </div>
              </div>
            </el-form-item>
          </div>
          <el-form-item label="商标文本" class="inline">
            <el-input
              :readonly="onlyshow"
              :class="onlyshow ? 'readonlit' : ''"
              v-model="formInfo.markup_text"
              class="formInput"
            ></el-input>
          </el-form-item>
          <el-form-item label="商标注册号" class="inline">
            <el-input
              :readonly="onlyshow"
              :class="onlyshow ? 'readonlit' : ''"
              v-model="formInfo.trademark_num"
              class="formInput"
            ></el-input>
          </el-form-item>
          <el-form-item label="注册日期" class="inline">
            <el-date-picker
              v-if="!onlyshow"
              :readonly="onlyshow"
              :class="onlyshow ? 'readonlit' : ''"
              type="date"
              v-model="formInfo.trademark_regist"
              class="formInput"
            >
            </el-date-picker>
            <div v-else>{{ formInfo.trademark_regist }}</div>
          </el-form-item>
          <el-form-item label="有效期至" class="inline">
            <el-date-picker
              v-if="!onlyshow"
              :readonly="onlyshow"
              :class="onlyshow ? 'readonlit' : ''"
              type="date"
              v-model="formInfo.trademark_expiration"
              class="formInput"
            >
            </el-date-picker>
            <div v-else>{{ formInfo.trademark_expiration }}</div>
          </el-form-item>

          <el-form-item label="产品注册商标" class="inlineTow">
            <div class="upControler">
              <Up :onlyshow="onlyshow" :length="1" v-model="product_brand"></Up>
              <div v-if="product_brand.length !== 0">
                <div
                  v-for="(val, ind) in product_brand"
                  :key="ind"
                  class="upFileImgList"
                >
                  <div class="upName">
                    <a :href="val.viewurl" target="_blank">上传的文件</a>
                  </div>
                  <i
                    @click="product_brand.splice(ind, 1)"
                    class="el-icon-delete del"
                    v-if="!onlyshow"
                  ></i>
                </div>
              </div>
              <div class="des">
                （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
              </div>
            </div>
          </el-form-item>

          <el-form-item
            v-if="formInfo.agent_type === 2"
            :required="true"
            label="信息登记授权委托书"
            class="inlineTow"
          >
            <a
              href="http://cldjadm.ynbzde.com/assets/file/attorneybooks.doc"
              download="信息登记授权委托书.doc"
            >
              下载信息登记授权委托书模板
            </a>
            <div class="upControler">
              <Up :onlyshow="onlyshow" :length="1" v-model="agent_book"></Up>
              <div v-if="agent_book.length !== 0">
                <div
                  v-for="(val, ind) in agent_book"
                  :key="ind"
                  class="upFileImgList"
                >
                  <div class="upName">
                    <a :href="val.viewurl" target="_blank">上传的文件</a>
                  </div>
                  <i
                    @click="agent_book.splice(ind, 1)"
                    class="el-icon-delete del"
                    v-if="!onlyshow"
                  ></i>
                </div>
              </div>
              <div class="des">
                （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
              </div>
            </div>
          </el-form-item>
          <!-- ---------------------------------------------------------新增加----------------------------- -->
          <el-form-item label="承诺书" :required="true" class="inlineTow">
            <div class="upControler">
              <Up :onlyshow="onlyshow" :length="1" v-model="promise_book"></Up>
              <div v-if="promise_book.length !== 0">
                <div
                  v-for="(val, ind) in promise_book"
                  :key="ind"
                  class="upFileImgList"
                >
                  <div class="upName">
                    <a :href="val.viewurl" target="_blank">上传的文件</a>
                  </div>
                  <i
                    @click="promise_book.splice(ind, 1)"
                    class="el-icon-delete del"
                    v-if="!onlyshow"
                  ></i>
                </div>
              </div>
              <div class="des">
                （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
              </div>
            </div>
            <a
              target="_blank"
              :href="
                domain +
                  '/assets/file/云南省建设工程材料及设备信息登记系统申报资料真实性承诺书.docx'
              "
              download="承诺书.docx"
            >
              点击下载承诺书
            </a>
          </el-form-item>
          <el-form-item
            v-if="false"
            label="质量承诺书"
            :required="true"
            class="inlineTow"
          >
            <div class="upControler">
              <Up :onlyshow="onlyshow" :length="1" v-model="quality_books"></Up>
              <div v-if="quality_books.length !== 0">
                <div
                  v-for="(val, ind) in product_brand"
                  :key="ind"
                  class="upFileImgList"
                >
                  <div class="upName">
                    <a :href="val.viewurl" target="_blank">上传的文件</a>
                  </div>
                  <i
                    @click="quality_books.splice(ind, 1)"
                    class="el-icon-delete del"
                    v-if="!onlyshow"
                  ></i>
                </div>
              </div>
              <div class="des">
                （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
              </div>
            </div>
            <a
              target="_blank"
              :href="domain + '/assets/file/quality_books_new.docx'"
              download="质量承诺书.docx"
            >
              点击下载质量承诺书模板
            </a>
          </el-form-item>
          <el-form-item label="环评批复文件" :required="true" class="inlineTow">
            <div class="miniTitle">
              建设项目环境影响评价分类管理名录
            </div>
            <div class="upControler">
              <Up
                :onlyshow="onlyshow"
                :length="1"
                v-model="environment_file"
              ></Up>
              <div v-if="environment_file.length !== 0">
                <div
                  v-for="(val, ind) in environment_file"
                  :key="ind"
                  class="upFileImgList"
                >
                  <div class="upName">
                    <a :href="val.viewurl" target="_blank">上传的文件</a>
                  </div>
                  <i
                    @click="environment_file.splice(ind, 1)"
                    class="el-icon-delete del"
                    v-if="!onlyshow"
                  ></i>
                </div>
              </div>
              <div class="des">
                （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
              </div>
            </div>
          </el-form-item>
          <el-form-item
            label="检测报告/出厂合格证明（检测时间2年内）"
            :required="true"
            class="inlineTow"
          >
            <div class="upControler">
              <Up
                :onlyshow="onlyshow"
                :length="1"
                v-model="factory_certificate"
              ></Up>
              <div v-if="factory_certificate.length !== 0">
                <div
                  v-for="(val, ind) in factory_certificate"
                  :key="ind"
                  class="upFileImgList"
                >
                  <div class="upName">
                    <a :href="val.viewurl" target="_blank">上传的文件</a>
                  </div>
                  <i
                    @click="factory_certificate.splice(ind, 1)"
                    class="el-icon-delete del"
                    v-if="!onlyshow"
                  ></i>
                </div>
              </div>
              <div class="des">
                （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
              </div>
            </div>
          </el-form-item>
          <el-form-item
            v-if="formInfo.agent_type === 2"
            :required="true"
            label="信息登记授权委托书"
            class="inlineTow"
          >
            <a
              href="http://cldjadm.ynbzde.com/assets/file/attorneybooks_new.doc"
              download="信息登记授权委托书.doc"
            >
              下载信息登记授权委托书模板
            </a>
            <div class="upControler">
              <Up :onlyshow="onlyshow" :length="1" v-model="agent_book"></Up>
              <div v-if="agent_book.length !== 0">
                <div
                  v-for="(val, ind) in agent_book"
                  :key="ind"
                  class="upFileImgList"
                >
                  <div class="upName">
                    <a :href="val.viewurl" target="_blank">上传的文件</a>
                  </div>
                  <i
                    @click="agent_book.splice(ind, 1)"
                    class="el-icon-delete del"
                    v-if="!onlyshow"
                  ></i>
                </div>
              </div>
              <div class="des">
                （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
              </div>
            </div>
          </el-form-item>

          <el-form-item label="其他相关资料" class="inlineTow">
            <div class="upControler">
              <Up :onlyshow="onlyshow" :length="1" v-model="other_file"></Up>
              <div v-if="other_file.length !== 0">
                <div
                  v-for="(val, ind) in other_file"
                  :key="ind"
                  class="upFileImgList"
                >
                  <div class="upName">
                    <a :href="val.viewurl" target="_blank">上传的文件</a>
                  </div>
                  <i
                    @click="other_file.splice(ind, 1)"
                    class="el-icon-delete del"
                    v-if="!onlyshow"
                  ></i>
                </div>
              </div>
              <div class="des">
                （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </Plan>

    <!--产品规格型号-->
    <Plan class="marginTop20" title="产品规格型号（必填）">
      <button
        v-if="!onlyshow"
        type="button"
        class="upBtn"
        @click="editGuige(null)"
      >
        添加规格型号
      </button>

      <el-table
        :data="attrspecs"
        stripe
        style="width: 100%"
        class="marginTop20"
      >
        <el-table-column label="序号">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="mspec" label="规格型号"> </el-table-column>
        <el-table-column prop="munit" label="计量单位"> </el-table-column>
        <el-table-column prop="wpu" label="单位重量"> </el-table-column>
        <el-table-column prop="shape" label="外形尺寸"> </el-table-column>
        <!-- <el-table-column prop="reportno" label="检测报告编号">
        </el-table-column>
        <el-table-column label="产品检验报告/出厂合格证明">
          <template slot-scope="scope">
            <span v-if="scope.row.reportfiles">
              <a :href="scope.row.reportfiles" target="_blank">
                预览文件
              </a>
            </span>
          </template>
        </el-table-column> -->
        <el-table-column label="状态">
          <template slot-scope="scope">
            <!--不是确认状态下的显示-->
            <div v-if="show !== 'confirm'">
              <div>
                <span
                  v-if="
                    scope.row.status === 0 ||
                      scope.row.status === 10 ||
                      scope.row.status === 12
                  "
                >
                  复审中
                </span>
                <span v-else-if="scope.row.status === 2">
                  待补充
                </span>
                <span v-else-if="scope.row.status === 1">
                  待确认
                </span>
                <span v-else-if="scope.row.status === 5">
                  公示中
                </span>
                <span v-else-if="scope.row.status === 6">
                  已赋码<span
                    v-if="
                      scope.row.codevalidtime * 1000 <= Date.parse(new Date())
                    "
                    >（已过期）</span
                  >
                </span>
                <span v-else-if="scope.row.status === 7">
                  附件核对中
                </span>
                <span v-else-if="scope.row.status === 11">
                  附件驳回
                </span>
                <span v-else-if="scope.row.status === 20">
                  终审中
                </span>
                <span v-else-if="scope.row.status === 100">
                  已删除
                </span>
              </div>
            </div>
            <!--确认状态下的状态确认-->
            <div v-if="show === 'confirm'">
              <span v-if="scope.row.status === 1">
                待确认
              </span>
              <span v-else-if="scope.row.status === 7">
                已确认
              </span>
              <span
                v-else-if="
                  scope.row.status === 0 ||
                    scope.row.status === 10 ||
                    scope.row.status === 12
                "
              >
                有疑议
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="code_time" label="有效期"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!--仅在可编辑模式显示-->
            <div v-if="!onlyshow">
              <!--待确认-->
              <div v-if="scope.row.status === 2">
                <el-button
                  @click="editGuige(scope.row, scope.$index)"
                  type="text"
                  size="small"
                >
                  修改
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="deletGuige(scope.row, scope.$index)"
                >
                  删除
                </el-button>
              </div>
              <!--删除还原-->
              <div v-if="scope.row.status === 100">
                <el-button
                  type="text"
                  size="small"
                  @click="reDeleteGuige(scope.row, scope.$index)"
                >
                  还原
                </el-button>
              </div>
            </div>
            <!--待确认-->
            <div v-if="show === 'confirm'">
              <el-button
                v-if="scope.row.status === 1"
                type="text"
                size="small"
                @click="comformGuige(scope.row, scope.$index)"
              >
                确认
              </el-button>
              <el-button
                v-if="scope.row.status === 1"
                type="text"
                size="small"
                @click="yiyiGuige(scope.row, scope.$index)"
              >
                有疑议
              </el-button>
            </div>
            <el-popover
              v-if="scope.row.status === 6"
              placement="top-start"
              width="200"
              trigger="hover"
            >
              <img style="width: 100%;" :src="scope.row.code_link" />
              <a
                download="二维码.png"
                slot="reference"
                :href="scope.row.code_link"
              >
                下载二维码
              </a>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </Plan>

    <Plan
      v-if="false"
      class="marginTop20"
      title="对产品或企业实行的许可等要求（选填）"
    >
      <el-form :inline="true" class="plan-form-inline">
        <el-form-item
          v-if="thisFInfo.coercive_file === 'normal'"
          label="CCC中国国家强制性产品认证证书"
          class="inlineTow"
        >
          <div class="miniTitle">强制性产品认证管理目录</div>
          <div class="upControler">
            <Up :onlyshow="onlyshow" :length="1" v-model="coercive_file"></Up>
            <div v-if="coercive_file.length !== 0">
              <div
                v-for="(val, ind) in coercive_file"
                :key="ind"
                class="upFileImgList"
              >
                <div class="upName">
                  <a :href="val.viewurl" target="_blank">上传的文件</a>
                </div>
                <i
                  @click="coercive_file.splice(ind, 1)"
                  class="el-icon-delete del"
                  v-if="!onlyshow"
                ></i>
              </div>
            </div>
            <div class="des">
              （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
            </div>
          </div>
        </el-form-item>

        <el-form-item
          v-if="thisFInfo.health_file === 'normal'"
          label="卫生许可批件"
          class="inlineTow"
        >
          <div class="miniTitle">涉及饮用水卫生安全产品分类目录</div>
          <div class="upControler">
            <Up :onlyshow="onlyshow" :length="1" v-model="health_file"></Up>
            <div v-if="health_file.length !== 0">
              <div
                v-for="(val, ind) in health_file"
                :key="ind"
                class="upFileImgList"
              >
                <div class="upName">
                  <a :href="val.viewurl" target="_blank">上传的文件</a>
                </div>
                <i
                  @click="health_file.splice(ind, 1)"
                  class="el-icon-delete del"
                  v-if="!onlyshow"
                ></i>
              </div>
            </div>
            <div class="des">
              （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
            </div>
          </div>
        </el-form-item>
        <el-form-item
          v-if="thisFInfo.special_file === 'normal'"
          label="特种设备制造许可证"
          class="inlineTow"
        >
          <div class="miniTitle">特种设备目录</div>
          <div class="upControler">
            <Up :onlyshow="onlyshow" :length="1" v-model="special_file"></Up>
            <div v-if="special_file.length !== 0">
              <div
                v-for="(val, ind) in special_file"
                :key="ind"
                class="upFileImgList"
              >
                <div class="upName">
                  <a :href="val.viewurl" target="_blank">上传的文件</a>
                </div>
                <i
                  @click="special_file.splice(ind, 1)"
                  class="el-icon-delete del"
                  v-if="!onlyshow"
                ></i>
              </div>
            </div>
            <div class="des">
              （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
            </div>
          </div>
        </el-form-item>
        <el-form-item
          v-if="thisFInfo.danger_file === 'normal'"
          label="有毒有害物质限量（含VOC）检验报告"
          class="inlineTow"
        >
          <div class="upControler">
            <Up :onlyshow="onlyshow" :length="1" v-model="danger_file"></Up>
            <div v-if="danger_file.length !== 0">
              <div
                v-for="(val, ind) in danger_file"
                :key="ind"
                class="upFileImgList"
              >
                <div class="upName">
                  <a :href="val.viewurl" target="_blank">上传的文件</a>
                </div>
                <i
                  @click="danger_file.splice(ind, 1)"
                  class="el-icon-delete del"
                  v-if="!onlyshow"
                ></i>
              </div>
            </div>
            <div class="des">
              （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
            </div>
          </div>
        </el-form-item>
        <el-form-item
          v-if="thisFInfo.calculate_file === 'normal'"
          label="计量器具型式批准证书、计量检定证书"
          class="inlineTow"
        >
          <div class="miniTitle">实施强制管理的计量器具目录</div>
          <div class="upControler">
            <Up :onlyshow="onlyshow" :length="1" v-model="calculate_file"></Up>
            <div v-if="calculate_file.length !== 0">
              <div
                v-for="(val, ind) in calculate_file"
                :key="ind"
                class="upFileImgList"
              >
                <div class="upName">
                  <a :href="val.viewurl" target="_blank">上传的文件</a>
                </div>
                <i
                  @click="calculate_file.splice(ind, 1)"
                  class="el-icon-delete del"
                  v-if="!onlyshow"
                ></i>
              </div>
            </div>
            <div class="des">
              （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
            </div>
          </div>
        </el-form-item>
        <el-form-item
          v-if="thisFInfo.mining_file === 'normal'"
          label="采矿许可证文件"
          class="inlineTow"
        >
          <div class="upControler">
            <Up :onlyshow="onlyshow" :length="1" v-model="mining_file"></Up>
            <div v-if="mining_file.length !== 0">
              <div
                v-for="(val, ind) in mining_file"
                :key="ind"
                class="upFileImgList"
              >
                <div class="upName">
                  <a :href="val.viewurl" target="_blank">上传的文件</a>
                </div>
                <i
                  @click="mining_file.splice(ind, 1)"
                  class="el-icon-delete del"
                  v-if="!onlyshow"
                ></i>
              </div>
            </div>
            <div class="des">
              （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
            </div>
          </div>
        </el-form-item>
        <el-form-item
          v-if="thisFInfo.newproduct_file === 'normal'"
          label="新产品鉴定/评审证书"
          class="inlineTow"
        >
          <div class="upControler">
            <Up :onlyshow="onlyshow" :length="1" v-model="newproduct_file"></Up>
            <div v-if="newproduct_file.length !== 0">
              <div
                v-for="(val, ind) in newproduct_file"
                :key="ind"
                class="upFileImgList"
              >
                <div class="upName">
                  <a :href="val.viewurl" target="_blank">上传的文件</a>
                </div>
                <i
                  @click="newproduct_file.splice(ind, 1)"
                  class="el-icon-delete del"
                  v-if="!onlyshow"
                ></i>
              </div>
            </div>
            <div class="des">
              （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
            </div>
          </div>
        </el-form-item>
        <el-form-item
          v-if="thisFInfo.entrance_file === 'normal'"
          label="进口产品入境货物通关单及进口商品检验合格证"
          class="inlineTow"
        >
          <div class="upControler">
            <Up :onlyshow="onlyshow" :length="1" v-model="entrance_file"></Up>
            <div v-if="entrance_file.length !== 0">
              <div
                v-for="(val, ind) in entrance_file"
                :key="ind"
                class="upFileImgList"
              >
                <div class="upName">
                  <a :href="val.viewurl" target="_blank">上传的文件</a>
                </div>
                <i
                  @click="entrance_file.splice(ind, 1)"
                  class="el-icon-delete del"
                  v-if="!onlyshow"
                ></i>
              </div>
            </div>
            <div class="des">
              （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
            </div>
          </div>
        </el-form-item>
        <el-form-item
          v-if="thisFInfo.industrial_file === 'normal'"
          label="全国工业产品生产许可证（工业产品生产许可证管理目录）"
          class="inlineTow"
        >
          <div class="upControler">
            <Up :onlyshow="onlyshow" :length="1" v-model="industrial_file"></Up>
            <div v-if="industrial_file.length !== 0">
              <div
                v-for="(val, ind) in industrial_file"
                :key="ind"
                class="upFileImgList"
              >
                <div class="upName">
                  <a :href="val.viewurl" target="_blank">上传的文件</a>
                </div>
                <i
                  @click="industrial_file.splice(ind, 1)"
                  class="el-icon-delete del"
                  v-if="!onlyshow"
                ></i>
              </div>
            </div>
            <div class="des">
              （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
            </div>
          </div>
        </el-form-item>
        <el-form-item label="其他相关资料" class="inlineTow">
          <div class="upControler">
            <Up :onlyshow="onlyshow" :length="1" v-model="other_file"></Up>
            <div v-if="other_file.length !== 0">
              <div
                v-for="(val, ind) in other_file"
                :key="ind"
                class="upFileImgList"
              >
                <div class="upName">
                  <a :href="val.viewurl" target="_blank">上传的文件</a>
                </div>
                <i
                  @click="other_file.splice(ind, 1)"
                  class="el-icon-delete del"
                  v-if="!onlyshow"
                ></i>
              </div>
            </div>
            <div class="des">
              （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
            </div>
          </div>
        </el-form-item>
      </el-form>
    </Plan>
    <!-- 优质类型证书选择填写 -->
    <!--下面是第四阶段-->
    <div v-for="(val, ind) in four" :key="ind">
      <Plan v-if="youzhiShow(val.id)" class="marginTop20" :title="val.name">
        <el-form :inline="true" class="plan-form-inline">
          <el-form-item label="填写证书编号" class="inline">
            <el-input
              :readonly="onlyshow"
              :class="onlyshow ? 'readonlit' : ''"
              v-model="four[ind].certificate_code"
              class="formInput"
            ></el-input>
          </el-form-item>
          <el-form-item label="选择规格型号" class="inline">
            <el-select
              filterable
              v-if="!onlyshow"
              v-model="four[ind].standard"
              class="formInput"
            >
              <el-option
                class="formInput"
                v-for="(val, ind) in speciModel"
                :key="ind"
                :label="val[0]"
                :value="val[0]"
              ></el-option>
            </el-select>
            <el-input
              v-else
              :readonly="onlyshow"
              :value="four[ind].standard"
              class="formInput readonlit"
            ></el-input>
          </el-form-item>
          <div></div>
          <el-form-item label="上传证书" class="inlineTow">
            <div class="upControler">
              <Up
                :onlyshow="onlyshow"
                :length="1"
                v-model="four[ind].certificate_file"
              ></Up>
              <div v-if="four[ind].certificate_file.length !== 0">
                <div
                  v-for="(val, ind) in four[ind].certificate_file"
                  :key="ind"
                  class="upFileImgList"
                >
                  <div class="upName">
                    <a :href="val.viewurl" target="_blank">上传的文件</a>
                  </div>
                  <i
                    @click="four[ind].certificate_file.splice(ind, 1)"
                    class="el-icon-delete del"
                    v-if="!onlyshow"
                  ></i>
                </div>
              </div>
              <div class="des">
                （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
              </div>
            </div>
          </el-form-item>
        </el-form>
      </Plan>
    </div>
    <!--下面是确认信息部分的逻辑 TODO 此处要删掉-->
    <div v-if="show === 'confirm' || show === 'reBank'">
      <div
        v-if="show === 'confirm'"
        style="text-align:center;"
        class="marginTop20"
      >
        <div @click="passway" class="yuanBtn2">核对完成,确认无误</div>
        <!-- <div
          class="yuanLouKongBtn"
          style="margin-left: 20px;"
          @click="subChangeTextModel = true"
        >
          产品信息有误
        </div> -->
      </div>
      <div
        v-if="show === 'reBank'"
        style="text-align:center;"
        class="marginTop20"
      >
        <div @click="succSure" class="yuanBtn2">确认修改</div>
      </div>
    </div>

    <!--状态10的时候显示-->
    <Plan
      style="display:none"
      v-if="show10 && show === 'show'"
      class="marginTop20"
      title="备注说明"
    >
      <div class="beizhuShuoMingController">
        <div v-if="imarks" style="font-size: 12px;">
          {{ imarks }}
        </div>
        <div v-else style="font-size: 12px;">
          暂未填写备注说明
        </div>

        <div class="marginTop20">
          <a
            style="font-size: 12px;"
            v-if="annexfies.length === 1"
            :href="annexfies[0].viewurl"
            target="_blank"
          >
            点击查看已上传附件
          </a>
          <div v-else class="marginTop20" style="font-size: 12px;">
            暂未上传附件
          </div>
        </div>
      </div>
    </Plan>

    <!--疑议内容-->
    <Plan
      v-if="show12 && show === 'show'"
      class="marginTop20"
      title="用户确认信息时的疑议内容"
    >
      <div class="beizhuShuoMingController">
        <div v-if="suremsg" v-html="suremsg" style="font-size: 12px;"></div>
        <div v-else style="font-size: 12px;">
          暂无用户确认信息时的疑议内容
        </div>
      </div>
    </Plan>

    <!--下面是模态框-->
    <!--下面是模态框-->

    <el-dialog
      title="材料分类选择"
      :visible.sync="showSelectCailiao"
      width="80%"
    >
      <div>
        <el-input
          style="width: 300px"
          placeholder="请输入内容"
          v-model="excelSo"
          class="input-with-select"
        >
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <div class="allClassTableShow marginTop20">
        <el-table :data="clDataLiExcel" style="width: 100%">
          <el-table-column prop="name1" label="一级分类"> </el-table-column>
          <el-table-column prop="name2" label="二级分类"> </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                @click="selectAExeter(scope.row)"
                type="text"
                size="small"
              >
                选择
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!--下面是添加规格型号的逻辑-->
    <!--下面是添加规格型号的逻辑-->
    <el-dialog title="添加规格型号" width="800px" :visible.sync="showGUigeMode">
      <el-form label-width="200px">
        <el-form-item :required="true" label="规格型号">
          <el-input v-model="subGuige.mspec"></el-input>
        </el-form-item>
        <el-form-item :required="true" label="计量单位">
          <el-select
            filterable
            v-model="subGuige.munit"
            placeholder="计量单位"
            style="width: 100%;"
          >
            <!--<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
            <el-option
              v-for="val in danweiList"
              :key="val"
              :label="val"
              :value="val"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单位重量">
          <el-input v-model="subGuige.wpu"></el-input>
        </el-form-item>
        <el-form-item label="外形尺寸">
          <el-input v-model="subGuige.shape"></el-input>
        </el-form-item>
        <!-- <el-form-item label="检测报告编号">
          <el-input v-model="subGuige.reportno"></el-input>
        </el-form-item>
        <el-form-item :required="true" label="产品检验报告/出厂合格证明">
          <div class="upControler" style="margin-top: 5px;">
            <Up :onlyshow="onlyshow" :length="1" v-model="subGuigeUpTemp"></Up>
            <div v-if="subGuigeUpTemp.length !== 0">
              <div
                v-for="(val, ind) in subGuigeUpTemp"
                :key="ind"
                class="upFileImgList"
              >
                <div class="upName">
                  <a :href="val.viewurl" target="_blank">上传的文件</a>
                </div>
                <i
                  @click="subGuigeUpTemp.splice(ind, 1)"
                  class="el-icon-delete del"
                  v-if="!onlyshow"
                ></i>
              </div>
            </div>
            <div class="des">
              （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
            </div>
          </div>
        </el-form-item> -->
        <div style="text-align: right;">
          <button type="button" class="upBtn" @click="subGuigeFun">
            立即创建
          </button>
        </div>
      </el-form>
    </el-dialog>

    <!--修改意见弹出框-->
    <el-dialog
      class="changeTextController"
      title="信息有误，提交修改意见"
      :visible.sync="subChangeTextModel"
      width="30%"
    >
      <div>
        <div>填写修改意见</div>
        <el-input
          class="marginTop20"
          type="textarea"
          :autosize="{ minRows: 6, maxRows: 10 }"
          style="width:100%;"
          placeholder="请填写修改意见"
          v-model="subChangeText"
        >
        </el-input>
      </div>
      <span slot="footer">
        <div @click="errorSure" class="yuanBtn2">提交</div>
      </span>
    </el-dialog>

    <!--需要完善产品信息-->
    <!--需要完善产品信息-->
    <Plan v-if="show === 'supplement'" class="marginTop20" title="备注说明">
      <div class="beizhuShuoMingController">
        <div class="lab">补充说明（必填）</div>
        <el-input
          class="marginTop20"
          type="textarea"
          :autosize="{ minRows: 6, maxRows: 10 }"
          style="width:100%;"
          placeholder="填写补充说明"
          v-model="imarks"
        >
        </el-input>
        <div class="marginTop20 lab">附件（选填）</div>
        <div class="marginTop20">
          <a
            style="font-size: 12px;"
            v-if="annexfies.length === 1"
            :href="annexfies[0].viewurl"
            target="_blank"
          >
            点击查看已上传附件
          </a>
          <Up v-else :length="1" v-model="annexfies"></Up>
        </div>
      </div>
    </Plan>
    <div
      v-if="show === 'supplement'"
      style="text-align:center;"
      class="marginTop20"
    >
      <div @click="sub" class="saveBtnController">确定</div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Areselect from "@/components/Areselect.vue";
import Plan from "@/components/Plan.vue";
import Categoryselect from "@/components/Categoryselect.vue";
import Up from "@/components/Up.vue";
import Api from "@/plugins/axios.js";
import { Loading } from "element-ui";
/**
 * 将文件数组转换为字符串
 */
function fileArrayToStr(fileArray) {
  if (fileArray !== null && fileArray !== "" && fileArray.length > 0) {
    return fileArray
      .map(function(e) {
        return e.url;
      })
      .join(",");
  } else {
    return "";
  }
}
// 从数组创造出文件列表
function buildFileArray(str) {
  if (str) {
    let arr = [];
    for (let index = 0; index < str.split(",").length; index++) {
      const element = str.split(",")[index];
      arr.push({
        name: "上传的文件",
        url: element,
        viewurl: Api.domain + element
      });
    }
    return arr;
  } else {
    return [];
  }
}
export default {
  name: "productSave",
  components: {
    Areselect,
    Up,
    Plan,
    Categoryselect
  },
  computed: {
    // 显示用的数组
    clDataLiExcel() {
      const that = this;
      if (this.excelSo) {
        return this.clDataLi
          .filter(function(e) {
            if (
              e.name1.indexOf(that.excelSo) !== -1 ||
              e.name2.indexOf(that.excelSo) !== -1 ||
              e.name3.indexOf(that.excelSo) !== -1 ||
              e.name4.indexOf(that.excelSo) !== -1
            ) {
              return true;
            } else {
              return false;
            }
          })
          .filter(function(e, ind) {
            if (ind >= 100) {
              return false;
            } else {
              return true;
            }
          });
      } else {
        return this.clDataLi.filter(function(e, ind) {
          if (ind >= 100) {
            return false;
          } else {
            return true;
          }
        });
      }
    },
    speciModel() {
      return this.speci_model.filter(function(re) {
        return re !== "" && re !== null;
      });
    }
  },
  data() {
    return {
      domain: Api.domain,
      // 当前页面的模式
      show: null,
      // 分类搜素关键词
      excelSo: "",
      // 分类列表
      clDataLi: [
        {
          id1: "",
          id2: "",
          id3: "",
          id4: "",
          name1: "",
          name2: "",
          name3: "",
          name4: ""
        }
      ],
      // 分类选择模态框打开和关闭
      showSelectCailiao: false,
      // 审核进度（文字版）
      check_text: null,
      // 审批意见
      checkmark: null,
      // 要显示的单位信息列表
      danweiList: [],
      // 分类显示字符串
      cate_tree: null,
      // 是否是显示模式
      onlyshow: false,
      youzhiList: [], // 优质类型
      thisFInfo: null, // 当前选中的分类二级分类的详情页
      // 规格型号
      speci_model: [],
      // JSON版本的规格型号
      attrspecs: [],
      // 是否是优质类型（控制输入框的显示）
      is_excelent_cate: "0",
      // 优质类型（选中的）
      excelent_cate: [],
      // 产品类别
      product_cate: [],
      // <a :href="val.viewurl" target="_blank">上传的文件</a>
      product_brand: [], // 产品注册商标
      promise_book: [], // 承诺书文件
      exam_report: [], // 产品质量检验合格证明
      agent_book: [], // 授权委托书
      // 下面是：对产品或企业实行的许可等要求的文件上传
      coercive_file: [],
      sewage_file: [],
      health_file: [],
      special_file: [],
      danger_file: [],
      calculate_file: [],
      mining_file: [],
      environment_file: [],
      newproduct_file: [],
      entrance_file: [],
      industrial_file: [],
      other_file: [], // 其他相关资料
      // 第四阶段提交的数据
      four: {
        greenmarks_info: {
          id: 38,
          name: "国家绿色建材评价标识编入证书",
          certificate_code: "",
          standard: "",
          certificate_file: []
        },
        greenauth_info: {
          id: 39,
          name: "绿色建材认证编入证书",
          certificate_code: "",
          standard: "",
          certificate_file: []
        },
        greenbuild_info: {
          id: 40,
          name: "云南省绿色装配式建筑“四新”与建材推广目录编入证书",
          certificate_code: "",
          standard: "",
          certificate_file: []
        }
      },
      areselect: [], // 地址三级下拉菜单
      // 总提交数组
      formInfo: {
        uuid: null, // 修改模式下的UUD
        product_name: "", // 产品名称
        product_output: "", // 产品年生产能力
        product_address: "", // 生产厂址
        amoun_unit: "", // 产能单位
        one_year: "", // 2019年产能
        two_year: "", // 2019年产能
        three_year: "", // 2019年产能
        product_unit: "", // 产品单位
        national_standard: "", //国家标准
        industry_standard: "", // 行业标准
        other_standard: "", // 其它标准
        // 新增字段
        trademark_num: "",
        trademark_regist: "",
        trademark_expiration: "",
        agent_id: null, // 生产厂商ID
        agent_type: null, // 1：生产厂商，2：代理（经销商）
        registered_address: [{ areCodeList: [], detail: "" }], //企业注册地址 多个
        markup_text: null
      },
      // 下面是添加规格型号的逻辑
      showGUigeMode: false,
      changeIndex: null, // 修改模式下的索引
      subGuige: {
        id: null,
        mspec: "",
        munit: "",
        wpu: "",
        shape: "",
        reportno: "",
        reportfiles: "",
        backmark: null
      }, // 一个数据变量
      subGuigeUpTemp: [], // 临时存储上传的数据
      // 下面是提交修改意见的模态框
      // 下面是提交修改意见的模态框
      xiugaiyijianIndex: null, // 修改意见的索引
      subChangeText: "", // 文字
      subChangeTextModel: false, // 模态框显示
      // 下面是承诺书字段
      // 下面是承诺书字段
      imsgfiles: [],
      // 下面是修改产品信息字段
      imarks: "", // 补充说明
      annexfies: [],
      // 状态12显示的备注
      // 状态12显示的备注
      suremsg: "",
      // 循环规格型号，来判断对应的框框要不要显示出来
      show7: false,
      show10: false,
      show12: false,
      now_years: new Date().getFullYear(),
      registered_address: "",
      instruct_book: [], // 产品说明书
      quality_books: [], //质量承诺书
      test_report: [],
      factory_certificate: [],
      stopinfo: {} //停用信息
    };
  },
  watch: {
    // 监听产品分类的二级分类
    async product_cate(val) {
      if (val[1]) {
        const re = await Api.buidDetail(val[1]);
        this.thisFInfo = re;
      }
    }
  },
  async mounted() {
    const that = this;

    // 进来的时候判断当前的操作模式是什么
    if (this.$route.query.show === "supplement") {
      // 重新修改信息的模式
      this.show = "supplement";
    } else if (this.$route.query.show === "show") {
      // 进入显示显示模式
      this.onlyshow = true;
      // 重新修改信息的模式
      this.show = "show";
    } else if (this.$route.query.show === "confirm") {
      // 进入显示显示模式
      this.onlyshow = true;
      // 确认信息的模式
      this.show = "confirm";
    } else if (this.$route.query.show === "reBank") {
      // 驳回的售后（状态11）
      // 进入显示显示模式
      this.onlyshow = true;
      // 确认信息的模式
      this.show = "reBank";
    }
    console.log("当前页面的模式", this.$route.query.show, this.show);

    // 获得Excel分类
    this.getExcelCLassLi();
    // 获得单位显示
    this.danweiList = await Api.getUnits();
    // 优质类型
    const li = await Api.getQyFl("excelent", 2);
    console.log("优质类型列表", li);
    this.youzhiList = li;
    // 判断是否有 uuid
    if (this.$route.query.uuid) {
      // 开始获得产品信息
      const info = await Api.infodetail(
        this.$store.state.token,
        this.$route.query.uuid
      );
      this.stopinfo = info.stopinfo;
      if (info.now_years) {
        this.now_years = info.now_years;
      }
      // 审核状态（文字版）
      this.check_text = info.check_text;
      // 审批意见
      this.checkmark = info.backmsg;

      // 产品规格型号计算
      let speci_model = info.speci_model ? info.speci_model.split(",") : [];
      let speci_modelR = [];
      for (let index = 0; index < speci_model.length; index++) {
        const element = speci_model[index];
        if (element.split("^").length >= 4) {
          let temp = element.split("^");
          if (temp[5]) {
            temp[5] = [
              {
                url: temp[5]
              }
            ];
          } else {
            temp[5] = [];
          }
          // 转成数组，涉及到文件上传对话框
          speci_modelR.push(temp);
        }
      }
      this.speci_model = speci_modelR;
      console.log("属性计算", this.speci_model);

      // JSON 版本的规格型号
      this.attrspecs = info.attrspecs
        .map(function(e) {
          if (e.status === 7) {
            that.show7 = true;
          }
          if (e.status === 10) {
            that.show10 = true;
          }
          if (e.status === 12) {
            that.show12 = true;
          }
          return e;
        })
        .filter(function(e) {
          // 重新修改信息
          if (that.show === "supplement" && e.status === 2) {
            return true;
          } else if (that.show === "confirm" && e.status === 1) {
            return true;
          } else if (that.show === "reBank" && e.status === 11) {
            return true;
          } else if (that.show === "show") {
            return true;
          } else {
            return false;
          }
        });

      // 选中的优质类型
      this.excelent_cate = info.excelent_cate
        ? info.excelent_cate.split(",").map(function(e) {
            return parseInt(e);
          })
        : [];
      // 判断是否直接显示选中的优质类型
      if (info.has_excellent === "yes") {
        this.is_excelent_cate = "1";
      }
      // 显示分类字符串
      this.cate_tree = info.cate_tree
        .map(function(e) {
          return e.name;
        })
        .join(",");

      // 承诺书计算
      if (this.show !== "confirm" && info.imsgfiles_domain) {
        this.imsgfiles = [
          {
            viewurl: info.imsgfiles_domain
          }
        ];
      }

      // 修改意见
      this.suremsg = info.suremsg;

      // 补充说明
      if (this.show !== "supplement") {
        this.imarks = info.imarks;
      }
      // 附件计算
      if (this.show !== "supplement" && info.annexfies_domain) {
        this.annexfies = [
          {
            viewurl: info.annexfies_domain
          }
        ];
      }

      // 分类计算
      this.product_cate = info.cate_tree.map(function(e) {
        return e.id.toString();
      });
      console.log("分类计算", info.cate_tree, this.product_cate);
      this.product_brand = buildFileArray(info.product_brand);
      this.promise_book = buildFileArray(info.promise_book);
      this.exam_report = buildFileArray(info.exam_report);
      this.agent_book = buildFileArray(info.agent_book);

      this.coercive_file = buildFileArray(info.coercive_file);
      this.sewage_file = buildFileArray(info.sewage_file);
      this.health_file = buildFileArray(info.health_file);
      this.special_file = buildFileArray(info.special_file);
      this.danger_file = buildFileArray(info.danger_file);
      this.calculate_file = buildFileArray(info.calculate_file);
      this.mining_file = buildFileArray(info.mining_file);
      this.environment_file = buildFileArray(info.environment_file);
      this.newproduct_file = buildFileArray(info.newproduct_file);
      this.entrance_file = buildFileArray(info.entrance_file);
      this.industrial_file = buildFileArray(info.industrial_file);
      this.other_file = buildFileArray(info.other_file);

      this.quality_books = buildFileArray(info.quality_books);
      this.test_report = buildFileArray(info.test_report);
      this.factory_certificate = buildFileArray(info.factory_certificate);
      // 下面开始处理第四阶段的文件上传
      for (const key in this.four) {
        this.four[key].certificate_code = info[key].certificate_code;
        this.four[key].standard = info[key].standard;
        this.four[key].certificate_file = buildFileArray(
          info[key].certificate_file
        ); // <a :href="val.viewurl" target="_blank">上传的文件</a>
        console.log("第四阶段", this.four[key]);
      }
      // 下面是三级地址下拉
      let areselect = [];
      if (info.province_code) {
        areselect[0] = info.province_code;
      }
      if (info.city_code) {
        areselect[1] = info.city_code;
      }
      if (info.area_code) {
        areselect[2] = info.area_code;
      }
      this.areselect = areselect;

      this.formInfo = {
        uuid: info.uuid,
        national_standard: info.national_standard,
        industry_standard: info.industry_standard,
        other_standard: info.other_standard,
        product_name: info.product_name,
        product_output: info.product_output,
        product_address: info.product_address,
        amoun_unit: info.amoun_unit,
        one_year: info.one_year,
        two_year: info.two_year,
        three_year: info.three_year,
        product_unit: info.product_unit,
        // 新增字段
        trademark_num: info.trademark_num,

        trademark_regist: info.trademark_regist,
        trademark_expiration: info.trademark_expiration,
        registered_address: info.registered_address
          ? info.registered_address
          : [{ areCodeList: [], detail: "" }],
        markup_text: info.markup_text,
        status: info.status
      };

      // 计算传入的ID信息
      if (info.agent_id) {
        this.formInfo.agent_id = parseInt(info.agent_id);
      }

      // 存储生产厂商ID
      if (this.$route.query.id) {
        this.formInfo.agent_id = parseInt(this.$route.query.id);
      }
      // 计算类型
      this.formInfo.agent_type = parseInt(info.agent_type);
    } else {
      this.$message.error("未选择正确的产品信息");
      this.$router.go(-1);
    }
  },
  methods: {
    // 选择一个Excel分类
    selectAExeter(e) {
      this.showSelectCailiao = false;
      let arr = [];
      if (e.id1) {
        arr.push(e.id1.toString());
      }
      if (e.id2) {
        arr.push(e.id2.toString());
      }
      if (e.id3) {
        arr.push(e.id3.toString());
      }
      if (e.id4) {
        arr.push(e.id4.toString());
      }
      this.product_cate = arr;
      console.log("选中的", this.product_cate);
    },
    // 获得Excel分类
    async getExcelCLassLi() {
      this.clDataLi = await Api.getExcelCLassLi();
      this.clDataLi = this.clDataLi.map(function(e) {
        return {
          id1: e.id1 ? e.id1 : null,
          name1: e.name1 ? e.name1 : "",
          id2: e.id2 ? e.id2 : null,
          name2: e.name2 ? e.name2 : "",
          id3: e.id3 ? e.id3 : null,
          name3: e.name3 ? e.name3 : "",
          id4: e.id4 ? e.id4 : null,
          name4: e.name4 ? e.name4 : ""
        };
      });
    },
    // 修改优质类型的时候清空优质类型选择
    changeYouzhiRadio() {
      this.excelent_cate = [];
    },
    async sub() {
      // 处理和计算注册和到期时间数据
      if (
        this.formInfo.trademark_regist &&
        this.formInfo.trademark_regist !== ""
      ) {
        this.formInfo.trademark_regist = moment(
          this.formInfo.trademark_regist
        ).format("YYYY-MM-DD");
      }
      if (
        this.formInfo.trademark_expiration &&
        this.formInfo.trademark_expiration !== ""
      ) {
        this.formInfo.trademark_expiration = moment(
          this.formInfo.trademark_expiration
        ).format("YYYY-MM-DD");
      }
      let sendData = {
        attrspecs: JSON.stringify(this.attrspecs), // JSON 版本的规格型号提交
        imarks: this.imarks, // 补充说明
        annexfies: fileArrayToStr(this.annexfies), // 补充附件
        excelent_cate: this.excelent_cate.join(","),
        product_cate: this.product_cate.join(","),
        product_brand: fileArrayToStr(this.product_brand), // 产品注册商标
        promise_book: fileArrayToStr(this.promise_book), // 承诺书文件
        exam_report: fileArrayToStr(this.exam_report), // 产品质量检验合格证明
        agent_book: fileArrayToStr(this.agent_book), // 授权委托书
        ...this.formInfo, // 传统字段表单
        province_code: this.areselect[0] ? this.areselect[0] : null, // 省
        city_code: this.areselect[1] ? this.areselect[1] : null, // 市
        area_code: this.areselect[2] ? this.areselect[2] : null, // 区
        // 就是中间那一大堆文件的上传处理
        coercive_file: fileArrayToStr(this.coercive_file),
        sewage_file: fileArrayToStr(this.sewage_file),
        health_file: fileArrayToStr(this.health_file),
        special_file: fileArrayToStr(this.special_file),
        danger_file: fileArrayToStr(this.danger_file),
        calculate_file: fileArrayToStr(this.calculate_file),
        mining_file: fileArrayToStr(this.mining_file),
        environment_file: fileArrayToStr(this.environment_file),
        newproduct_file: fileArrayToStr(this.newproduct_file),
        entrance_file: fileArrayToStr(this.entrance_file),
        industrial_file: fileArrayToStr(this.industrial_file),
        other_file: fileArrayToStr(this.other_file) // 其他相关资料
      };
      // 先处理第四阶段上传的数据
      for (const key in this.four) {
        const element = this.four[key];
        sendData[key] = {
          certificate_code: element.certificate_code, // 编号
          standard: element.standard, // 规格型号
          certificate_file: fileArrayToStr(element.certificate_file) // <a :href="val.viewurl" target="_blank">上传的文件</a>
        };
      }
      console.log("全部计算完成", sendData);
      const loadingInstance = Loading.service({ fullscreen: true });
      try {
        // 产品信息补充提交
        await Api.repairSub(this.$store.state.token, sendData);
        this.$msgbox({ title: "提示", type: "success", message: "操作成功" });
        this.$router.push({
          name: "ProductList"
        });
      } catch (error) {
        this.$msgbox({ title: "提示", type: "error", message: error });
      }
      loadingInstance.close();
    },
    // 根据优质类型显示和隐藏
    youzhiShow(val) {
      for (let index = 0; index < this.excelent_cate.length; index++) {
        const element = this.excelent_cate[index].toString();
        if (val.toString() === element) {
          return true;
        }
      }
      return false;
    },
    back() {
      this.$router.push({
        query: {
          save: "save",
          uuid: this.formInfo.uuid,
          id: this.formInfo.agent_id,
          savetype:
            this.formInfo.agent_type === 1 ? "shenchanshang" : "dailishang2"
        },
        name: "ProductInfoSave"
      });
    },
    // 添加规格型号的逻辑
    // 添加规格型号的逻辑
    subGuigeFun() {
      if (
        !this.subGuige.mspec ||
        !this.subGuige.munit ||
        !this.subGuigeUpTemp ||
        this.subGuigeUpTemp.length === 0
      ) {
        this.$msgbox({
          title: "提示",
          type: "error",
          message: "必须填写规格型号、计量单位和检测报告"
        });
      } else {
        // 计算上传的文件
        if (this.subGuigeUpTemp.length > 0) {
          this.subGuige.reportfiles = this.subGuigeUpTemp[0].viewurl;
        }
        // 判断是新增还是修改
        if (this.changeIndex === null) {
          this.attrspecs.push(this.subGuige);
        } else {
          this.$set(this.attrspecs, this.changeIndex, this.subGuige);
        }
        this.showGUigeMode = false;
      }
    },
    // 修改规格
    editGuige(data, ind) {
      if (data) {
        // 当前修改的下标
        this.changeIndex = ind;
        // 修改的数据集合
        this.subGuige = {
          ...data
        };
        if (data.reportfiles) {
          // 把现在有的文件计算到临时变量
          this.subGuigeUpTemp = [
            {
              viewurl: data.reportfiles
            }
          ];
        } else {
          // 清空临时上传数据
          this.subGuigeUpTemp = [];
        }
      } else {
        this.changeIndex = null;
        this.subGuige = {
          id: null,
          mspec: "",
          munit: "",
          wpu: "",
          shape: "",
          reportno: "",
          reportfiles: "",
          backmark: null
        };
        // 清空临时上传数据
        this.subGuigeUpTemp = [];
      }
      this.showGUigeMode = true;
    },
    // 删除规格
    deletGuige(data, ind) {
      this.attrspecs[ind].status = 100;
    },
    // 还原删除
    reDeleteGuige(data, ind) {
      // 还原到待补充状态
      this.attrspecs[ind].status = 2;
    },
    // 规格型号确认
    comformGuige(data, ind) {
      this.attrspecs[ind].status = 7;
    },
    // 规格型号存在疑义
    yiyiGuige(data, ind) {
      // 打开框框
      this.subChangeTextModel = true;
      // 存储索引
      this.xiugaiyijianIndex = ind;
    },
    // 下面是确认的时候的逻辑方法
    // 下面是确认的时候的逻辑方法
    // 确认了
    async succSure() {
      // 承诺书
      const imsgfiles = fileArrayToStr(this.imsgfiles);
      try {
        await Api.succSure(
          this.$store.state.token,
          this.formInfo.uuid,
          imsgfiles
        );
        this.$msgbox({
          title: "提示",
          type: "success",
          message: "信息确认成功"
        });
        this.$router.push({
          name: "ProductList"
        });
      } catch (error) {
        this.$msgbox({ title: "提示", type: "error", message: error });
      }
    },
    // 确认产品信息
    async passway() {
      // 承诺书
      const imsgfiles = fileArrayToStr(this.imsgfiles);
      try {
        await Api.passway(
          this.$store.state.token,
          this.formInfo.uuid,
          imsgfiles,
          JSON.stringify(this.attrspecs)
        );
        this.$msgbox({ title: "提示", type: "success", message: "确认成功" });
        this.$router.push({
          name: "ProductList"
        });
      } catch (error) {
        this.$msgbox({ title: "提示", type: "error", message: error });
      }
    },
    // 提出疑问
    async errorSure() {
      if (this.subChangeText === "") {
        this.$msgbox({
          title: "提示",
          type: "error",
          message: "请填写修改意见"
        });
        return false;
      }
      this.attrspecs[this.xiugaiyijianIndex].status = 12;
      this.attrspecs[this.xiugaiyijianIndex].suremsg = this.subChangeText;
      this.subChangeTextModel = false;
      this.subChangeText = "";
    },
    addDress() {
      let tempress = this.formInfo.registered_address;
      tempress.push({ areCodeList: [], detail: "" });
      this.formInfo.registered_address = tempress;
    }
  }
};
</script>
<style lang="less">
// readonly模式下的预览
.readonlit {
  .el-input__inner {
    border: 0px solid #dcdfe6;
    padding: 0px;
    font-weight: bold;
  }
}
</style>
<style lang="less" scoped>
.plan-form-inline {
  .inline {
    width: calc(33% - 10px);
  }
  .isExcelent {
    padding-top: 40px;
    margin-bottom: 0;
    /deep/ .el-form-item__label {
      font-weight: bold;
      color: #333;
      margin: 2px 20px 0 10px;
    }
  }
  .selecteExcelentCate {
    /deep/ .el-form-item__content {
      display: block !important;
    }
    /deep/ .el-checkbox-button__inner {
      border: 1px solid #dcdfe6;
      border-radius: 30px;
      margin-right: 10px;
    }
    /deep/ .el-checkbox-button.is-checked .el-checkbox-button__inner {
      border-color: #0082a4;
      background: transparent;
      color: #0082a4;
    }
    /deep/ .el-checkbox-button__inner:hover {
      color: #0082a4;
    }
  }
  .productOutputCompany {
    /deep/ .el-select {
      width: 316px !important;
    }
    /deep/ .el-form-item__content {
      display: block !important;
      width: 100%;
    }
  }
  .actualOutPutTitle {
    font-size: 14px;
    color: #606266;
    margin-bottom: 10px;
    span {
      color: #ccc;
    }
  }
  .actualOutPut {
    /deep/ .el-input {
      width: auto;
      margin-right: 6px;
    }
  }
  .productArea {
    .areSelectaddress {
      display: flex;
    }
    /deep/ .el-form-item__content {
      display: block !important;
    }
    /deep/ .el-select {
      margin-right: 20px;
      width: 210px;
    }
    /deep/ .productArea_address {
      width: 500px;
      display: inline-block;
    }
  }
  .inlineTow {
    width: calc(50% - 10px);
    .miniTitle {
      margin-top: -15px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      opacity: 1;
    }
  }
  .formInput {
    width: calc(1100px / 3 - 50px);
  }
  .formInputFive {
    width: 150px;
    // width: calc(1100px / 5 - 50px);
  }
  .inLinePlan {
    display: flex;
    align-items: center;
    // 添加按钮输入框
    .addController {
      margin-top: -25px;
      width: 100px;
      min-width: 100px;
      .add {
        cursor: pointer;
        font-size: 12px;
        color: rgba(0, 177, 255, 1);
        opacity: 1;
      }
      .del {
        cursor: pointer;
        font-size: 12px;
        color: rgba(153, 153, 153, 1);
        opacity: 1;
      }
    }
  }
}
// 上传按钮
.upControler {
  display: flex;
  align-items: center;
  .des {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 16px;
    color: rgba(204, 204, 204, 1);
    opacity: 1;
  }
}
// readonly下单纯的显示字符的样式
.inputShow {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  opacity: 1;
}
.textAligt {
  text-align: center;
}
.upFileImgList {
  height: 26px;
  display: flex;
  align-items: center;
  font-size: 12px;
  min-width: 100px;
  .del {
    color: red;
    cursor: pointer;
    margin-left: 15px;
    font-size: 20px;
  }
  .upName {
    min-width: 120px;
    a {
      color: black;
      text-decoration: none;
    }
  }
}
</style>
<style lang="less" scoped>
// 像下面这段是切换条属性
.small {
  margin-top: 20px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 10px rgba(151, 190, 255, 0.17);
}
.fix {
  position: relative !important;
}
.total {
  display: flex;
  padding-top: 14px;
  border-bottom: 1upx solid #e5e5e5;
}
.size {
  font-size: 16px;
  text-align: center;
  padding-left: 38px;
  padding-right: 38px;
  margin-bottom: 14px;
}
.grayStyle {
  font-weight: normal;
  color: rgba(153, 153, 153, 1);
}
.lineStyle {
  width: 82px;
  height: 2px;
  margin: auto;
}
.blackStyle {
  font-weight: normal;
  color: rgba(0, 130, 164, 1);
}
.blackLine {
  background: rgba(0, 130, 164, 1);
}
// 公示对话框
.small {
  margin-top: 20px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 10px rgba(151, 190, 255, 0.17);
  .top {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    display: flex;
    align-items: center;
    padding-top: 18px;
    padding-bottom: 8px;
    padding-left: 38px;
    border-bottom: 1px solid rgba(230, 230, 230, 1);
  }
  .topName {
    font-size: 16px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
  .topBtn {
    margin-left: 18px;
    padding-left: 5px;
    padding-right: 5px;
    background: rgba(255, 0, 0, 1);
    opacity: 1;
    border-radius: 7px;
    text-align: center;
    font-size: 10px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    height: 14px;
  }
  .topBtnBlue {
    width: 52px;
    height: 14px;
    background: rgba(0, 130, 164, 1);
    opacity: 1;
    border-radius: 7px;
    font-size: 10px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    text-align: center;
  }
  .bottom {
    padding: 30px 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .bottomL {
    display: flex;
  }
  .add {
    font-size: 12px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
}
// 所有分类的显示
.allClassTableShow {
  max-height: 500px;
  overflow: auto;
}

// 产品标题
.chanpinTitleControler {
  display: flex;
  align-items: center;
  .ts {
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 130, 164, 1);
    opacity: 1;
    padding-bottom: 15px;
    border-bottom: 2px solid rgba(0, 130, 164, 1);
    margin-bottom: -15px;
  }
  .flex {
    flex: 1;
  }
  .bank {
    cursor: pointer;
    color: #0082a4;
    font-size: 12px;
    font-weight: 400;
    color: rgba(0, 130, 164, 1);
    opacity: 1;
  }
}

// 反馈意见
.fankuiyijianController {
  display: flex;
  align-items: center;
  .fankuiyijian {
    min-width: 50px;
    margin-right: 15px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    opacity: 1;
  }
  .yijian {
    font-size: 12px;
    font-weight: 400;
    color: rgba(0, 177, 255, 1);
    opacity: 1;
  }
}
// 警示
.jinshiText {
  // margin-top: 5px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 0, 0, 1);
  opacity: 1;
}

// 修改意见弹出框的样式修改
.changeTextController {
  /deep/ .el-dialog__header {
    background-color: #f0f5f7;
  }
  /deep/ .el-dialog__body {
    padding: 20px;
  }
  /deep/ .el-dialog__footer {
    background-color: #f0f5f7;
  }
}
// 承诺书上传对话框样式
.chengnuoshuUpController {
  .des {
    font-size: 12px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    opacity: 1;
  }
  .upCon {
    margin-top: 10px;
    display: flex;
    align-items: center;
    a {
      font-size: 12px;
    }
  }
  .huise {
    margin-top: 10px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(204, 204, 204, 1);
    opacity: 1;
  }
}

// 备注说明
.beizhuShuoMingController {
  .lab {
    font-size: 12px;
  }
}
</style>
